import { QueryFunctionContext } from "@tanstack/react-query";

import {
  GetCheckoutSessionRequest,
  PaymentMethodTypeCode,
} from "frontend-client";

import { fetchClient } from "./fetch-client";

type CheckoutSessionQueryKeys = Array<{
  apiHost: string;
  version: string;
  checkoutSessionToken: string;
  scope: "checkout-session";
  isCreditCardMop?: boolean;
}>;
export const fetchCheckoutSession = ({
  queryKey: [{ apiHost, version, checkoutSessionToken, isCreditCardMop }],
}: QueryFunctionContext<CheckoutSessionQueryKeys>) => {
  const request = new GetCheckoutSessionRequest({
    methodOfPayment: isCreditCardMop
      ? PaymentMethodTypeCode.CREDIT_CARD
      : undefined,
  });
  return fetchClient({ apiHost, version }).getCheckoutSession(request, {
    headers: {
      Authorization: "Bearer " + checkoutSessionToken,
    },
  });
};
